import { CanalEnvio, Rol, TipoProfesional } from '@/types/enums';

export const TIPO_PROFESIONAL_LABELS: Record<TipoProfesional, string> = {
  [TipoProfesional.VETERINARIO]: 'Veterinario/a',
  [TipoProfesional.INGENIERO_AGRONOMO]: 'Ingeniero/a agrónomo/a',
  [TipoProfesional.OTRO]: 'Otro',
};

export const CANAL_ENVIO_LABELS: Record<CanalEnvio, string> = {
  [CanalEnvio.EMAIL]: 'Email',
  [CanalEnvio.WHATSAPP]: 'WhatsApp',
};

export const ROL_LABELS: Record<Rol, string> = {
  [Rol.ADMINISTRADOR]: 'Administrador',
  [Rol.TECNICO_LABORATORIO]: 'Técnico de laboratorio',
  [Rol.PROFESIONAL]: 'Profesional',
  [Rol.ESTABLECIMIENTO]: 'Establecimiento',
};
